import * as echarts from 'echarts';
import { addSeries } from './addSeries.js';
import printscreen from "../../../src/assets/printscreen.png";
import download from "../../../src/assets/download.png"
// 计算矩形左右边界和垂直线位置
// const xleft = 0.16261135688041312;
// const xright = 0.27387024311958685;
// const trd_obs_mu = 0.2182408;
const xleft = 0.1732;
const xright = 0.229;
const trd_obs_mu = 0.2011;

// 更新图表数据的函数
function updateChart(data) {

    // 初始化 ECharts 实例
    const seriesDataAll = addSeries(data);
    const series1 = seriesDataAll.series1;
    const series0 = seriesDataAll.series0;
    const y_max = data['y_max'];
    const model_name = data['model_name'];
    const myChart = echarts.init(document.getElementById('chart'));
    const hec_proj_period = data['hec_proj_period_df'];
    const dataframe = combineArraysToDataFrame(model_name, hec_proj_period);


    // 配置图表选项
    var option = {
        series: [...series1, ...series0,],
        title: {
            text: 'Line Chart',
            show: false
        },
        dataZoom: [
            {
                type: 'inside',
                yAxisIndex: [0, 1, 2], xAxisIndex: [0, 1, 2],
            },
        ],
        tooltip: {
            trigger: 'axis',
            triggerOn: 'mousemove|click',
            formatter: function (params) {
                var res = "";
                for (var i = 0; i < params.length; i++) {
                    var series = params[i];
                    if (series.seriesName == window.selectSeries) {
                        if (series.seriesName == 'trd_delta') {
                            res = model_name[series.dataIndex] + "<br/>" + 'X:&nbsp&nbsp' + series.axisValue.toFixed(2) + '°C/decade' + "<br/>" + 'Y:&nbsp&nbsp' + series.data[1].toFixed(2) + '°C' + "<br/>"
                        }
                        else if (model_name.includes(series.seriesName)) {
                            if (series.data[1] !== null && series.data[1] !== undefined) {
                                res = series.marker + series.seriesName + "<br/>" + 'X:&nbsp;&nbsp' + series.axisValue + "<br/>" + 'Y:&nbsp;&nbsp' + series.data[1].toFixed(2) + '°C' + "<br/>";
                            }
                        }
                        else if (series.seriesName == 'Constrained' || series.seriesName == 'Unconstrained') {
                            res = series.marker + series.seriesName;
                        }
                        break;
                    }
                }
                return res;
            }
        },
        toolbox: {
            "show": true,
            "orient": 'horizontal',
            "itemSize": 25,
            "itemGap": 5,
            "right": 10,
            "textSize":25,
            showTitle: false,
            // right: 100, 
            // itemSize: 25, itemGap: 20,
            tooltip: { // 和 option.tooltip 的配置项相同
                show: true,
                formatter: function (param) {
                    return '<div>' + param.title + '</div>'; // 自定义的 DOM 结构
                },
                // formatter: function (param) {
                //     return param.title ; // 自定义的 DOM 结构
                // },
                backgroundColor: "rgba(255,255,255,1)",
                textStyle: {
                    fontSize: 20,
                    color: "#4b9fc9",
                },
                // extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            },
            feature: {
                saveAsImage: { 
                show: true, 
                title: 'save Image', 
                "pixelRatio": 1,
                // icon: 'image://' + printscreen
                "icon":'path://M581.12 753.28v137.6h206.72a34.56 34.56 0 1 1 0 69.12H305.28a34.56 34.56 0 1 1 0-69.12H512v-137.6H201.6A137.6 137.6 0 0 1 64 615.68V201.6A137.6 137.6 0 0 1 201.6 64h689.28a137.6 137.6 0 0 1 137.6 137.6v414.08a137.6 137.6 0 0 1-137.6 137.6zM201.6 133.12a69.76 69.76 0 0 0-68.48 68.48v414.08a69.76 69.76 0 0 0 69.12 69.12h688.64A69.76 69.76 0 0 0 960 615.68V201.6a69.76 69.76 0 0 0-69.12-69.12z',
                iconStyle: {
                    borderColor: "#8a8a8a",  // 图标默认颜色
                },
                emphasis: {
                    iconStyle: {
                        borderColor: "#4b9fc9",  // 图标hover颜色
                    },
                },
             },
                myTxt: {
                    show: true, 
                    title: 'export model and period', 
                    // icon: 'image://' + download,
                    icon: 'path://M857.6 956.8H166.4c-54.4 0-102.4-48-102.4-105.6v-182.4c0-19.2 12.8-32 32-32s32 12.8 32 32v182.4c0 22.4 16 41.6 38.4 41.6h694.4c19.2 0 38.4-19.2 38.4-41.6v-182.4c0-19.2 12.8-32 32-32s32 12.8 32 32v182.4c-3.2 57.6-48 105.6-105.6 105.6z M512 758.4c-19.2 0-32-12.8-32-32v-640c0-19.2 12.8-32 32-32s32 12.8 32 32v640c0 16-12.8 32-32 32z M512 764.8c-9.6 0-16-3.2-22.4-9.6l-208-208c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0l185.6 185.6 185.6-185.6c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8l-208 208c-6.4 6.4-12.8 9.6-22.4 9.6z',
                    "pixelRatio": 1,
                    iconStyle: {
                        borderColor: "#8a8a8a",  // 图标默认颜色
                    },
                    emphasis: {
                        iconStyle: {
                            borderColor: "#4b9fc9",  // 图标hover颜色
                        },
                    },
                    onclick: function () {
                        exportToText(dataframe, 'model_and_period.csv')
                    }
                },
            }
        },

        grid: [
            {
                x: 100,
                y: 50,
                width: 660,
                height: 550,
                show: false,
                tooltip: {
                    show: true,
                    trigger: 'axis'
                }
            },
            {
                x: 780,
                y: 50,
                width: 140,
                height: 550,
                show: false,
                tooltip: {
                    show: true,
                    trigger: 'axis'
                }
            },
            {
                x: 920,
                y: 50,
                width: 520,
                height: 550,
                show: false,
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    axisPointer: { show: false }
                }
            }],
        xAxis: [{
            gridIndex: 0, // 这个值很重要，用于指定图表组件属于哪个画布
            type: 'value',
            name: 'Warming trend during 1971-2020 (°C/decade)',
            nameLocation: 'middle',
            boundaryGap: false,
            nameTextStyle: {
                fontWeight: 'normal', fontSize: 25,
                padding: [40, 0, 0, 0], color: '#222121'
            }, //上右下左
            min: 0,
            max: 0.5,
            axisTick: {
                show: true, inside: false, length: 10,
                lineStyle: { width: 2 }
            },
            axisLabel: {
                showMinLabel: false,
                showMaxLabel: false,
                margin: 15,
                fontSize: 25
            },
            splitLine: {     //网格线
                "show": false
            },
            axisLine: {
                onZero: false,
                lineStyle: {
                    // color: 'green', // 设置折线颜色
                    width: 2,      // 设置折线宽度
                    type: 'solid'  // 设置折线样式，solid为实线，dashed为虚线，dotted为点线
                },
            },
        },
        {
            gridIndex: 1, // 这个值很重要，用于指定图表组件属于哪个画布
            type: 'value',
            boundaryGap: false,
            min: 0,
            max: function (value) {
                return value.max + 0.05;
            },
            splitLine: {     //网格线
                "show": false
            },
            axisTick: { show: false }, // 隐藏刻度线
            axisLabel: {
                "show": false,
                fontSize: 16
            }, // 隐藏刻度值
            axisLine: {
                onZero: false,
                lineStyle: {
                    // color: 'green', // 设置折线颜色
                    width: 2,      // 设置折线宽度
                    type: 'solid'  // 设置折线样式，solid为实线，dashed为虚线，dotted为点线
                },
            },
        },

        {
            gridIndex: 2, // 这个值很重要，用于指定图表组件属于哪个画布
            type: 'value',
            name: 'Year',
            nameLocation: 'middle',
            nameTextStyle: {
                fontWeight: 'normal', fontSize: 25,
                padding: [40, 0, 0, 0], color: '#222121'
            }, //上右下左
            min: 2000,
            max: 2095,
            boundaryGap: false,
            interval: 20,
            splitLine: { "show": false },   //网格线
            axisTick: {
                show: true, inside: false, length: 10,
                lineStyle: { width: 2 }
            },
            axisLabel: {
                showMaxLabel: false,
                showMinLabel: true,
                margin: 15,
                fontStyle: 'normal',
                fontSize: 22,
                formatter: function (value) {
                    return value.toFixed(0); // 将浮点数转换为整数并返回               
                }
            },
            axisLine: {
                symbol: 'none',
                symbolOffset: 5,
                onZero: false,
                lineStyle: {
                    // color: 'green', // 设置折线颜色
                    width: 2,      // 设置折线宽度
                    type: 'solid'  // 设置折线样式，solid为实线，dashed为虚线，dotted为点线
                },
            },
        },
        ],
        yAxis: [{
            gridIndex: 0, // 这个值很重要，用于指定图表组件属于哪个画布
            name: 'Future warming relative to 1850-1900 (°C)',
            nameLocation: 'middle',
            nameTextStyle: {
                fontWeight: 'normal', fontSize: 25,
                padding: [0, 0, 50, 0], color: '#222121'
            }, //上右下左
            position: 'left',
            splitLine: {     //网格线
                "show": false
            },
            type: 'value',
            min: 0,
            max: y_max,
            interval: 1,
            axisLabel: {
                showMaxLabel: false, margin: 15,
                fontSize: 25,
            },
            axisTick: {
                show: true, inside: false, length: 10,
                lineStyle: { width: 2 }
            },
            axisPointer: {
                snap: true
            },
            axisLine: {
                symbol: 'none',
                symbolOffset: 5,
                onZero: false,
                lineStyle: {
                    // color: 'green', // 设置折线颜色
                    width: 2,      // 设置折线宽度
                    type: 'solid'  // 设置折线样式，solid为实线，dashed为虚线，dotted为点线
                },
            },

        },

        {
            gridIndex: 1, // 这个值很重要，用于指定图表组件属于哪个画布
            position: 'left',
            splitLine: {     //网格线
                "show": false
            },
            type: 'value',
            min: 0,
            max: y_max,
            interval: 1,
            axisLabel: {
                showMinLabel: false, showMaxLabel: false,
                show: false, fontSize: 16,
            },
            axisTick: { show: false, inside: false },
            axisPointer: {
                snap: true
            },
            axisLine: {
                symbol: 'none',
                show: false,
                symbolOffset: 5,
                onZero: false,
                lineStyle: {
                    color: 'green', // 设置折线颜色
                    width: 2,      // 设置折线宽度
                    type: 'solid'  // 设置折线样式，solid为实线，dashed为虚线，dotted为点线
                },
            },
        },

        {
            gridIndex: 2, // 这个值很重要，用于指定图表组件属于哪个画布
            splitLine: {     //网格线
                "show": false
            },
            type: 'value',
            min: 0,
            max: y_max,
            interval: 1,
            axisTick: { show: false },
            axisPointer: { show: false },
            axisLabel: {
                "show": false,
                fontStyle: 'normal'
            },
            alignTicks: false,
            axisLine: {
                show: false,
                symbol: 'none',
                lineStyle: {
                    color: 'green', // 设置折线颜色
                    width: 2,      // 设置折线宽度
                    type: 'solid'  // 设置折线样式，solid为实线，dashed为虚线，dotted为点线
                },
            },
        },
        ],

    };
    // 设置图表选项
    myChart.setOption(option, true);
    //当 鼠标移到线条上时触发
    myChart.on('mousemove', function (params) {
        window.selectSeries = params.seriesName;
    });
    //当 鼠标移出线条时触发 ，如果不处理这个，鼠标移到空白上还有tooltip显示。
    myChart.on('mouseout', function (params) {
        window.selectSeries = '';
    });

    //随着屏幕大小调节图表
    window.addEventListener("resize", () => {
        myChart.resize();
    });
    // series1=[];
    //清空数组，避免多次请求，数据重复添加。
}

function exportToText(data, filename) {

    // 构建 CSV 内容,添加列名
    var csvContent = "model name,start year,end year\n";

    // 添加数据行
    data.forEach(function (row) {
        csvContent += row.model_name + "," + row.start_year + "," + row.end_year + "\n";
    });

    // 创建一个 Blob 对象，将 CSV 内容转换为字符串
    var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });

    // 创建下载链接
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    // 触发点击事件以下载文件
    link.click();
}

function combineArraysToDataFrame(model_name, hec_period) {
    // 定义空数组来存储结果
    var result = [];
    // 遍历 model_name 数组
    for (var i = 0; i < model_name.length; i++) {
        // 获取当前模型名称和对应的时间段
        var modelName = model_name[i];
        var period = hec_period[i];
        // 创建对象，表示一行数据
        var row = {
            model_name: modelName,
            start_year: period[0],
            end_year: period[1]
        };
        // 将当前行添加到结果数组中
        result.push(row);
    }
    // 返回结果数组
    return result;
}


export {
    updateChart
}